export default "__VITE_ASSET__RtIfAXTp__"